"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Zerox = exports.ZeroXOrder = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const utils_1 = require("@0x/utils");
const adapter_1 = __importDefault(require("./adapter"));
const weth_1 = require("./weth");
const ERC20_ABI = require("../../abi/erc20.json");
const ZRX_V2_ABI = require("../../abi/zrx.v2.json");
const ZRX_V3_ABI = require("../../abi/zrx.v3.json");
const ZRX_V4_ABI = require("../../abi/zrx.v4.json");
const ZRX_EXCHANGE = {
    1: {
        2: '0x080bf510fcbf18b91105470639e9561022937712',
        3: '0x61935CbDd02287B511119DDb11Aeb42F1593b7Ef',
        4: '0xdef1c0ded9bec7f1a1670819833240f027b25eff',
    },
    56: {
        2: '0x3F93C3D9304a70c9104642AB8cD37b1E2a7c203A',
        4: '0xdef1c0ded9bec7f1a1670819833240f027b25eff',
    },
};
const ZRX_ABI = {
    2: ZRX_V2_ABI,
    3: ZRX_V3_ABI,
    4: ZRX_V4_ABI,
};
const ZRX_EXCHANGE_ERC20PROXY = {
    1: {
        1: '0x95E6F48254609A6ee006F7D493c8e5fB97094ceF',
        2: '0x95E6F48254609A6ee006F7D493c8e5fB97094ceF',
        4: '0xdef1c0ded9bec7f1a1670819833240f027b25eff',
    },
    56: {
        2: '0xCF21d4b7a265FF779accBA55Ace0F56C8cE6e379',
        4: '0xdef1c0ded9bec7f1a1670819833240f027b25eff',
    },
};
var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["INVALID"] = 0] = "INVALID";
    OrderStatus[OrderStatus["INVALID_MAKER_ASSET_AMOUNT"] = 1] = "INVALID_MAKER_ASSET_AMOUNT";
    OrderStatus[OrderStatus["INVALID_TAKER_ASSET_AMOUNT"] = 2] = "INVALID_TAKER_ASSET_AMOUNT";
    OrderStatus[OrderStatus["FILLABLE"] = 3] = "FILLABLE";
    OrderStatus[OrderStatus["EXPIRED"] = 4] = "EXPIRED";
    OrderStatus[OrderStatus["FULLY_FILLED"] = 5] = "FULLY_FILLED";
    OrderStatus[OrderStatus["CANCELLED"] = 6] = "CANCELLED";
})(OrderStatus || (OrderStatus = {}));
class ZeroXOrder extends adapter_1.default {
    static formatOrderV4(order, version) {
        return {
            makerToken: order.makerToken,
            takerToken: order.takerToken,
            makerAmount: new bignumber_js_1.default(order.makerAmount).toFixed(),
            takerAmount: new bignumber_js_1.default(order.takerAmount).toFixed(),
            maker: order.maker,
            taker: order.taker,
            txOrigin: order.txOrigin,
            pool: order.pool,
            expiry: new bignumber_js_1.default(order.expiry).toFixed(),
            salt: new bignumber_js_1.default(order.salt).toFixed(),
        };
    }
    static formatOrderV23(order, version) {
        const feeAssetData = version === 3
            ? {
                makerFeeAssetData: order.makerFeeAssetData,
                takerFeeAssetData: order.takerFeeAssetData,
            }
            : {};
        return Object.assign({ makerAddress: order.makerAddress, takerAddress: order.takerAddress, feeRecipientAddress: order.feeRecipientAddress, senderAddress: order.senderAddress, makerAssetAmount: new bignumber_js_1.default(order.makerAssetAmount).toFixed(0), takerAssetAmount: new bignumber_js_1.default(order.takerAssetAmount).toFixed(0), makerFee: new bignumber_js_1.default(order.makerFee).toFixed(0), takerFee: new bignumber_js_1.default(order.takerFee).toFixed(0), expirationTimeSeconds: new bignumber_js_1.default(order.expirationTimeSeconds).toFixed(0), salt: new bignumber_js_1.default(order.salt).toFixed(0), makerAssetData: order.makerAssetData, takerAssetData: order.takerAssetData }, feeAssetData);
    }
    static formatOrders(orders, version = 2) {
        return version === 4
            ? orders.map(o => ZeroXOrder.formatOrderV4(o, version))
            : orders.map(o => ZeroXOrder.formatOrderV23(o, version));
    }
}
exports.ZeroXOrder = ZeroXOrder;
class Zerox extends adapter_1.default {
    static getDexData(optimalRate, name) {
        return {
            name,
            srcAmount: optimalRate.srcAmount,
            destAmount: '1',
            minConversionRate: '1',
            orders: optimalRate.data.orders,
            signatures: optimalRate.data.orders.map((o) => o.signature),
            networkFees: optimalRate.data.networkFees || '0',
            version: optimalRate.data.version || 2,
        };
    }
    getExchange(data) {
        return ZRX_EXCHANGE[this.network][data.version];
    }
    buildSwapData(data) {
        const zrxABI = ZRX_ABI[data.version];
        const orders = ZeroXOrder.formatOrders(data.orders, data.version);
        const takerAssetFillAmount = new bignumber_js_1.default(data.srcAmount);
        const signatures = data.signatures;
        const methodAbi = zrxABI.find((m) => m.name ===
            (data.version === 4 ? 'fillRfqOrder' : 'marketSellOrdersNoThrow'));
        const abiEncoder = new utils_1.AbiEncoder.Method(methodAbi);
        // TODO: fillLimitOrder only accepts one order, find something that can accept multiple orders
        return abiEncoder.encode(data.version === 4
            ? [orders[0], signatures[0], takerAssetFillAmount]
            : [orders, takerAssetFillAmount, signatures]);
    }
    isFillable(order, provider) {
        return __awaiter(this, void 0, void 0, function* () {
            const orderInfo = yield this.getOrderInfo(order, provider);
            return Number(orderInfo.orderStatus) === OrderStatus.FILLABLE;
        });
    }
    getOrderInfo(order, provider) {
        return __awaiter(this, void 0, void 0, function* () {
            const contract = new this.web3Provider.eth.Contract(ZRX_V3_ABI, ZRX_EXCHANGE[this.network][3]);
            return contract.methods.getOrderInfo(order).call();
        });
    }
    getTokenToTokenSwapData(srcToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const approveCallData = yield this.getApproveCallData(srcToken, data.srcAmount, ZRX_EXCHANGE_ERC20PROXY[this.network][data.version]);
            const assetSwapperData = this.buildSwapData(data);
            const networkFees = data.networkFees || '0';
            const callees = approveCallData
                ? [this.augustus._address, this.getExchange(data)]
                : [this.getExchange(data)];
            const calldata = approveCallData
                ? [approveCallData.calldata, assetSwapperData]
                : [assetSwapperData];
            const values = approveCallData ? ['0', networkFees] : [networkFees];
            return {
                callees,
                calldata,
                values,
            };
        });
    }
    ethToTokenSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const wethToken = weth_1.Weth.getAddress(this.network);
            const wethContract = new this.web3Provider.eth.Contract(ERC20_ABI, wethToken);
            const depositWethData = wethContract.methods.deposit().encodeABI();
            const wethToTokenData = yield this.getTokenToTokenSwapData(wethToken, data);
            return {
                callees: [wethToken, ...wethToTokenData.callees],
                calldata: [depositWethData, ...wethToTokenData.calldata],
                values: [data.srcAmount, ...wethToTokenData.values],
            };
        });
    }
    tokenToEthSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const wethToken = weth_1.Weth.getAddress(this.network);
            const wethToTokenData = yield this.getTokenToTokenSwapData(srcToken, data);
            const withdrawWethData = this.augustus.methods
                .withdrawAllWETH(wethToken)
                .encodeABI();
            return {
                callees: [...wethToTokenData.callees, this.augustus._address],
                calldata: [...wethToTokenData.calldata, withdrawWethData],
                values: [...wethToTokenData.values, '0'],
            };
        });
    }
    tokenToTokenSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const swapData = yield this.getTokenToTokenSwapData(srcToken, data);
            return {
                callees: [...swapData.callees],
                calldata: [...swapData.calldata],
                values: [...swapData.values],
            };
        });
    }
}
exports.Zerox = Zerox;
//# sourceMappingURL=zerox.js.map